import { motion } from 'framer-motion';
import { useCallback, useEffect, useRef, useState } from 'react';
import { sports } from '../data/mockData';

const SPORT_ROTATE_MS = 2600;

export function SportsTabsSection() {
  const [activeSportIndex, setActiveSportIndex] = useState(0);
  const pauseRef = useRef(false);

  const advance = useCallback(() => {
    setActiveSportIndex((i) => (i + 1) % sports.length);
  }, []);

  useEffect(() => {
    const id = window.setInterval(() => {
      if (!pauseRef.current) advance();
    }, SPORT_ROTATE_MS);
    return () => window.clearInterval(id);
  }, [advance]);

  return (
    <section className="border-b border-brand-border">
      <div
        className="mx-auto flex w-full max-w-5xl items-center justify-center gap-5 overflow-x-auto px-4 pb-6 pt-2 text-base font-medium text-zinc-200 sm:px-6"
        onMouseEnter={() => {
          pauseRef.current = true;
        }}
        onMouseLeave={() => {
          pauseRef.current = false;
        }}
      >
        {sports.map((sport, index) => (
          <button
            key={`${sport}-${index}`}
            type="button"
            className={`relative shrink-0 px-0.5 pb-2 transition ${
              activeSportIndex === index ? 'text-brand-yellow' : 'hover:text-brand-yellow'
            }`}
            onClick={() => setActiveSportIndex(index)}
            aria-current={activeSportIndex === index ? 'true' : undefined}
          >
            {sport}
            {activeSportIndex === index ? (
              <motion.span
                layoutId="sport-highlight-bar"
                className="absolute -bottom-0.5 left-0 right-0 h-0.5 rounded-full bg-brand-yellow shadow-[0_0_12px_rgba(215,194,4,0.45)]"
                transition={{ type: 'spring', stiffness: 420, damping: 34 }}
              />
            ) : null}
          </button>
        ))}
      </div>
    </section>
  );
}
